import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';

@Component({
  selector: 'td-wb-learn-toolbar-panel',
  templateUrl: 'learn-toolbar-panel.component.html',
  styleUrls: ['learn-toolbar-panel.component.scss'],
  imports: [
    AsyncPipe
  ]
})
export class LearnToolbarPanelComponent implements OnInit {
  private readonly mediaQueryService = inject(MediaQueryService);

  breakpointChanges$: Observable<BreakpointState>;

  ngOnInit(): void {
    this.breakpointChanges$ = this.mediaQueryService.observe(Breakpoint.LT_MD);
  }
}

